export enum INVITATION_STATE {
  "DRAFT" = "DRAFT",
  "SCHEDULED" = "SCHEDULED",
  "SENT" = "SENT",
}
export enum INVITATION_ATTENDEE_STATE {
  "CREATED" = "CREATED",
  "SENT" = "SENT",
  "REMINDER" = "REMINDER",
}
